// PennyDrop Dialog

import { APAsyncButton, APButton, APCard, APColouredIcon, APColumn, APExpanded, APIconButton, APPalette, APRow, APScrollView, APSizedBox, APText, APTypography, CloseIcon, Deferred, getIt } from "ap-components";
import { useState } from "react";
import AdminModel from "../../Models/AdminModel";
import EmpanelmentService from "../../Services/EmpanelmentService";
import { launchPage } from "../../Common/Utils";

export function PennyDropDialog(props: { deferred: Deferred<{ retry?: boolean, admin?: AdminModel, token?: string, failedDrop?: boolean, manual?: boolean }>, accountNumber: string, ifsc: string, bankProof?: string }) {
    const [isAccountVerified, setisAccountVerified] = useState<boolean | undefined>(undefined);

    return (
        <APCard style={{ padding: "16px", minWidth: "100%", maxWidth: "100%", boxSizing: "border-box", borderRadius: "8px" }}>
            <APColumn gap='8px' mainAxisSize="max" crossAxisAlignment="stretch">
                <APRow gap='8px' mainAxisAlignment='spaceBetween'>
                    <APExpanded>
                        <APText variant='h3' color={APPalette['grey-700']} ellipsis>Penny Drop</APText>
                    </APExpanded>
                    {
                        <APIconButton onClick={() => props.deferred?.reject(new Error("Please click on Submit to verify bank details."))}>
                            <CloseIcon />
                        </APIconButton>
                    }
                </APRow>
                <APExpanded>
                    <APScrollView>
                        <APRow mainAxisAlignment="center" mainAxisSize="max"><APColouredIcon icon='taxSavings' size={100} /></APRow>
                        <APSizedBox height="12px" />
                        {isAccountVerified === undefined && <APText>We will deposit <b>₹1</b> to your bank account for verification. Click <b>'Ok'</b> to confirm</APText>}
                        {isAccountVerified === false &&
                            <APColumn mainAxisAlignment='start'>
                                <APSizedBox height="12px" />
                                <APCard padding='6px 8px 6px 8px' style={{ backgroundColor: `${APPalette['negative-100']}`, width: '100%', borderRadius: '8px', borderColor: `${APPalette['negative-300']}` }}>
                                    <APRow mainAxisAlignment='center' crossAxisAlignment='center'>
                                        <APText style={{ ...APTypography["paragraph-large"], color: APPalette["negative-300"] }}>Bank Verification failed</APText>
                                    </APRow>
                                </APCard>
                                <APSizedBox height="12px" />
                                <APText center style={APTypography["paragraph-large"]}>We couldn't verify your bank details. Retry with another account or upload proof to continue</APText>
                            </APColumn>
                        }
                        <APSizedBox height="28px" />
                    </APScrollView>
                </APExpanded>
                {/* Card Actions */}
                <APRow mainAxisAlignment='start' gap='8px' mainAxisSize="max">
                    {!isAccountVerified && <APButton size='medium' style={{ width: '50%' }} type='secondary' onClick={() => { props.deferred.resolve({ retry: true }) }}>{isAccountVerified === undefined ? "Cancel" : "Retry with another A/C"}</APButton>}
                    <APAsyncButton size='medium' style={{ width: `${isAccountVerified ? "100%" : "50%"}` }} onClick={async () => {
                        if (isAccountVerified === undefined) {
                            try {
                                const res = await getIt(EmpanelmentService).saveBankDetailsv2({ accountNumber: props.accountNumber, ifsc: props.ifsc, bankImageBase64: props.bankProof });
                                props.deferred.resolve({ admin: res.admin, token: res.token });
                            } catch (err: any) {
                                const metaData = err?.response?.data.metaData;
                                if (!!metaData) {
                                    if (metaData.invalidSignup) {
                                        launchPage('/signup/verification');
                                    } else if (metaData.noData) {
                                        setisAccountVerified(false);
                                    } else if (metaData.manual) {
                                        props.deferred.resolve({ manual: true })
                                    }
                                } else {
                                    setisAccountVerified(false);
                                }
                            }
                        } else {
                            props.deferred.resolve({ failedDrop: true });
                        }
                    }} >{isAccountVerified === false ? "Upload Proof" : "Ok"}</APAsyncButton>
                </APRow>
            </APColumn>
        </APCard>
    );
}
